<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/settings/user">Users</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-2">
              <b-row>
                <b-col md="12">
                  <b-form class="mt-3 mx-2">
                    <b-row>
                      <b-col md="4">
                        <label class="labels">first name</label>
                        <div class="form-group" v-bind:class="errors.has('firstName') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('firstName') ? 'is-invalid':''" v-validate="'required'" data-vv-as="first name" name="firstName" v-model="model.firstName" placeholder="First Name" />
                          <p v-if="errors.has('firstName') !== null" class="invalid-feedback">{{errors.first('firstName')}}</p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">last name</label>
                        <div class="form-group" v-bind:class="errors.has('lastName') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('lastName') ? 'is-invalid':''" v-validate="'required'" data-vv-as="last name" name="lastName" v-model="model.lastName" placeholder="Last Name" />
                          <p v-if="errors.has('lastName') !== null" class="invalid-feedback">{{errors.first('lastName')}}</p>
                        </div>
                      </b-col>
                      <b-col md="2">
                        <label class="labels">Phone</label>
                        <div class="form-group" v-bind:class="errors.has('phone') ? 'has-error':''">
                          <input type="number" class="form-control" v-bind:class="errors.has('phone') ? 'is-invalid':''" v-validate="'required'" data-vv-as="phone" name="phone" v-model="model.phone" placeholder="Phone" />
                          <p v-if="errors.has('phone') !== null" class="invalid-feedback">{{errors.first('phone')}}</p>
                        </div>
                      </b-col>
                      <b-col md="2">
                        <label class="labels">leave quota</label>
                        <div class="form-group" v-bind:class="errors.has('leaveQuota') ? 'has-error':''">
                          <input type="number" class="form-control" v-bind:class="errors.has('leaveQuota') ? 'is-invalid':''" v-validate="'required'" data-vv-as="Leave Quota" name="leaveQuota" v-model="model.leaveQuota" placeholder="Leave Quota" />
                          <p v-if="errors.has('leaveQuota') !== null" class="invalid-feedback">{{errors.first('leaveQuota')}}</p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">address</label>
                        <div class="form-group" v-bind:class="errors.has('address') ? 'has-error':''">
                            <b-form-textarea rows="3" type="text" class="form-control" v-bind:class="errors.has('address') ? 'is-invalid':''" v-validate="'required'" data-vv-as="address" name="address" v-model="model.address" placeholder="Address" />
                            <p v-if="errors.has('address') !== null" class="invalid-feedback">{{errors.first('address')}}</p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <label class="labels">Role</label>
                        <div class="form-group" v-bind:class="errors.has('role') ? 'has-error':''">
                          <input v-if="this.$route.params.id !== undefined" class="form-control" type="text" readonly v-model="model.role" />
                          <select v-else placeholder="Role" v-model="model.role" v-validate="'required'" name="role" class="form-control">
                            <option value="">Select a role</option>
                            <option value="Admin">Admin</option>
                            <option value="Manager">Manager</option>
                            <option value="Supervisor">Supervisor</option>
                            <option value="User">User</option>
                          </select>
                          <p v-if="errors.has('role') !== null" class="invalid-feedback">{{errors.first('role')}}</p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">Branch</label>
                        <div class="form-group" v-bind:class="errors.has('branch') ? 'has-error':''">
                          <b-form-select class="form-control" v-model="model.branch" v-bind:class="errors.has('branch') ? 'is-invalid':''" v-validate="'required'" name="branch" :error="errors.first('branch')"  :options="collections.branch"></b-form-select>
                          <p v-if="errors.has('branch') !== null" class="invalid-feedback">{{errors.first('branch')}}</p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">department</label>
                        <div class="form-group" v-bind:class="errors.has('department') ? 'has-error':''">
                          <b-form-select class="form-control" v-model="model.department" v-bind:class="errors.has('department') ? 'is-invalid':''" v-validate="'required'" name="department" :error="errors.first('department')"  :options="collections.department"></b-form-select>
                          <p v-if="errors.has('department') !== null" class="invalid-feedback">{{errors.first('department')}}</p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <template v-if="$route.params.id === undefined">
                          <label class="labels">email</label>
                          <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                            <input type="text" class="form-control" v-bind:class="errors.has('email') ? 'is-invalid':''" v-validate="'required'" data-vv-as="email" name="email" v-model="model.email" placeholder="Email" />
                            <p v-if="errors.has('email') !== null" class="invalid-feedback">{{errors.first('email')}}</p>
                          </div>
                        </template>
                      </b-col>
                      <b-col md="4">
                        <template v-if="$route.params.id === undefined">
                          <label class="labels">username</label>
                          <div class="form-group" v-bind:class="errors.has('username') ? 'has-error':''">
                            <input type="text" class="form-control" v-bind:class="errors.has('username') ? 'is-invalid':''" v-validate="'required'" data-vv-as="username" name="username" v-model="model.username" placeholder="Username" />
                            <p v-if="errors.has('username') !== null" class="invalid-feedback">{{errors.first('username')}}</p>
                          </div>
                        </template>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">password</label>
                        <div class="form-group" v-bind:class="errors.has('password') ? 'has-error':''">
                          <input type="password" class="form-control" v-bind:class="errors.has('password') ? 'is-invalid':''" v-validate="this.$route.params.id !== undefined ? 'min:8' : 'required|min:8'" data-vv-as="password" name="password" v-model="model.password" placeholder="Password" />
                          <p v-if="errors.has('password') !== null" class="invalid-feedback">{{errors.first('password')}}</p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-col>
              </b-row>
              <div class="mt-2">
                <b-button class="mr-2" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : 'Save'}} </b-button>
              </div>
            </form>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'user-details',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    profile: window.AppConfig.apiUrl + 'profile',
                },
                model: {
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    branch: '',
                    phone: '',
                    department: '',
                    role: '',
                    username: '',
                    leaveQuota: '',
                },
                collections: {
                  branch: [{
                    value: "",
                    text: "Select a branch"
                  }],
                  department: [{
                    value: "",
                    text: "Select a department"
                  }]
                }
            }
        },
        mounted () {
            this.initData()
            this.initBranchList()
            this.initDepartmentList()
        },
        methods: {
            initData() {
              if (this.$route.params.id !== undefined){
                this.getDetail()
              }
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.profile + '/' + this.$route.params.id).then(response => {
                  this.model.email = response.data.email !== null ? response.data.email : '-'
                  this.model.password = response.data.password !== null ? response.data.password : '-'
                  this.model.firstName = response.data.firstName !== null ? response.data.firstName : '-'
                  this.model.lastName = response.data.lastName !== null ? response.data.lastName : '-'
                  this.model.username = response.data.username !== null ? response.data.username : '-'
                  this.model.address = response.data.address !== null ? response.data.address : '-'
                  this.model.phone = response.data.phone !== null ? response.data.phone : '-'
                  this.model.branch = response.data.branch !== null ? response.data.branch.uuid : '-'
                  this.model.department = response.data.department !== null ? response.data.department.uuid : '-'
                  this.model.role = response.data.role !== null ? response.data.role : '-'
                  this.model.leaveQuota = response.data.leaveQuota !== null ? response.data.leaveQuota : '-'
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    break
                case 'Requested':
                    return 'info'
                    break
                case 'Rejected':
                    return 'danger'
                    break
                }
            },
            initBranchList () {
              this.$http.get(window.AppConfig.apiUrl + 'branch').then(response => {
                response.data._embedded.branch.forEach(data => {
                  this.collections.branch.push({
                    value: data.uuid,
                    text: data.name
                  })
                })
              })
            },
            initDepartmentList () {
              this.$http.get(window.AppConfig.apiUrl + 'department').then(response => {
                response.data._embedded.department.forEach(data => {
                  this.collections.department.push({
                    value: data.uuid,
                    text: data.name
                  })
                })
              })
            },
            doSubmit () {
              this.$validator.validateAll().then(res => {
                if (res) {
                  if (this.$route.params.id !== undefined) {
                    let model = {
                      firstName: this.model.firstName,
                      lastName: this.model.lastName,
                      role: this.model.role,
                      branch: this.model.branch,
                      department: this.model.department,
                      address: this.model.address,
                      phone: this.model.phone,
                      leaveQuota: this.model.leaveQuota,
                    }
                    if (this.model.password !== '') {
                      model.password = this.model.password
                    }
                    this.$http.patch(this.apiUrl.profile + '/' + this.$route.params.id, model).then(response => {
                      this.$store.dispatch('notification/success', 'User has been updated.')
                      window.location.href = document.URL.replace('/edit', '')
                    }).catch(error => {
                      this.$store.dispatch('notification/error', error)
                    })
                  } else {
                    this.$http.post(this.apiUrl.profile, this.model).then(response => {
                      this.$store.dispatch('notification/success', 'User has been added.')
                      window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
                    }).catch(error => {
                      this.$store.dispatch('notification/error', error)
                    })
                  }
                }
              })
            },
        }
    }
</script>